import * as React from 'react';
import { Field, FieldHint, FieldLabel, FieldMessage, Textarea } from '@repo/ui-web';
import { textareaStates } from '../../catalog/component-states';
import { StateToggle } from '../../components/StateToggle';

type TextareaState = (typeof textareaStates)[number];

export function TextareaShowcase() {
  const [state, setState] = React.useState<TextareaState>('default');

  return (
    <div className="space-y-4">
      <StateToggle options={textareaStates} value={state} onChange={setState} label="State" />
      <Field>
        <FieldLabel>Message</FieldLabel>
        <Textarea
          placeholder="Share details"
          disabled={state === 'disabled'}
          error={state === 'error'}
        />
        {state === 'error' ? (
          <FieldMessage>Please add at least 10 characters.</FieldMessage>
        ) : (
          <FieldHint>Optional</FieldHint>
        )}
      </Field>
    </div>
  );
}
